/* eslint-disable import/no-internal-modules */
import { CartIconButtonV2 } from "user_site/features/cart";
import { WithProviders } from "user_site/utils";

const Component = () => (
  <WithProviders>
    <CartIconButtonV2 />
  </WithProviders>
);

export default Component;
